import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import MuiTabs from '@mui/material/Tabs'
import MuiTab from '@mui/material/Tab'
import {StyledTitle} from '../../AdminPanelStyling'

export const StyledContainer = styled(Box)(() => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden'
}))

export const StyledTabsHeader = styled(Box)(({theme}) => ({
  borderBottom: 1,
  borderColor: 'divider',
  marginLeft: theme.spacing(-4),
  marginRight: theme.spacing(-4),
  flexShrink: 0
}))

export const StyledTabs = styled(MuiTabs)(({theme}) => ({
  paddingLeft: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`
}))

export const StyledTab = styled(MuiTab, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})(({theme, isActive}) => ({
  fontWeight: isActive ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular,
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
    borderRadius: theme.spacing(0.5)
  }
}))

export const StyledTabPanelRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})(({theme, isActive}) => ({
  marginTop: theme.spacing(2),
  flex: 1,
  display: isActive ? 'flex' : 'none',
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden'
}))

export const StyledTabPanelTitle = styled(StyledTitle)(({theme}) => ({
  flexShrink: 0,
  marginBottom: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}))

export const StyledTabPanelContent = styled(Box)(({theme}) => ({
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
  paddingBottom: theme.spacing(3)
}))
